import CLASS_NAMES from '../class-list';

const {
  OVERLAY,
} = CLASS_NAMES;

const overlay: string =
  `<div 
    class="${OVERLAY}"
    tabIndex="-1">
  </div>`
;

export default overlay;



// WEBPACK FOOTER //
// ../node_modules/tslint-loader??ref--1!./modules/markup/overlay.ts